import React, { FC, Fragment, useEffect } from "react";
import { FontIcon, Image } from "@fluentui/react";
import { ISofProps } from "./TruckSofPage";
import { mergeStyleSets } from "@fluentui/react";
import { ActivityLog, ProcessFlowStep } from "../../models/ProcessFlowConfig";
import { LineHandling, SofView, TruckNomination } from "../../models";
import { toOrdinalString } from "../../services/Helper";
import { useState } from "react";
import ApiSpinner from "../common/ApiSpinner";
import Moment from "react-moment";
import SofIcon from "../common/Icons";
import "moment-timezone";
import { SofProcessor } from "../../services/SofProcessor";

import { pushNotification } from "../../api/pushNotification";
import { useHistory, useParams } from "react-router-dom";
import queryString from "query-string";
import moment from "moment";
import NextStateModal, { NextActionType } from "../sof/NextStateModal";
import NominationsStatusPane from "../sof/NominationsStatusPane";
import ActionModal from "./ActionModal";
import TimeStampModal from "./TimeStampModal";
import RejectionImageUploadModal from "./RejectionImageUploadModal";

interface Props extends ISofProps {
  className: string | undefined;
  nominationNo: string | undefined;
  rejectionStatus: number | undefined;
}

type ActivityItem = {
  status?: number;
  startedOn?: string;
  finishedOn?: string;
  description?: string;
  surveyor?: string;
  order?: number;
  isStartOffline: boolean;
  isEndOffline: boolean;
};

const classes = mergeStyleSets({
  disabledBG: {
    background: "rgba(255, 255, 255, 0.4)",
    position: "fixed",
    bottom: 0,
    right: 0,
    width: "calc(58% - 75px)",
    height: "calc(75vh - 48px)",
    zIndex: 999,
  },
  filler: {
    height: 600,
  },
});

const activeStatus = [0, 1, 2, 5];

const ActivityLogsPage: FC<Props> = (props: Props) => {
  const { sofView, config, selectedState } = props;
  const { activityLogs, truckNomination } = props;
  let param = useParams() as any;
  const nominationNo = param.lineHandlingNo;

  //const [lineHandlingNo, setLineHandlingNo] = useState("");
  // const [nominationNo, setNominationNo] = useState<string>();
  const [selectedStateId, setSelectedStateId] = useState(0);
  const [steps, setSteps] = useState<ProcessFlowStep[]>([]);
  const [selectedStep, setSelectedStep] = useState<ProcessFlowStep>();
  const [surveyor, setSurveyor] = useState<string>();
  const [showActionModal, setShowActionModal] = useState(false);
  const [showRejectImgUploadModal, setShowRejectImgUploadModal] =
    useState(false);
  const [showTimeStampModal, setShowTimeStampModal] = useState(false);
  const [newState, setNewState] = useState("");
  const [modalMessage, setModalMessage] = useState("");
  const [showNewStateModal, setShowNewStateModal] = useState(false);
  const [nextActionType, setNextActionType] = useState(
    NextActionType.NEXT_STATE
  );
  const history = useHistory();

  const renderMessage = (message: string) => (
    <div key="msg" className="no-activity">
      <SofIcon iconname="Exclamation2" />

      <p
        key="no-activity"
        style={{
          fontWeight: 400,
          color: "",
          width: "250px",
          margin: "10px auto 0 auto",
        }}
      >
        {message}
      </p>
    </div>
  );

  const scrollIntoActiveView = () => {
    const divActiveSectionElement = document.getElementById("first-active-row");
    if (divActiveSectionElement !== null) {
      divActiveSectionElement.scrollIntoView({ behavior: "auto" });
    } else {
      const activitiesPane = document.getElementById("activities-pane");
      if (activitiesPane) activitiesPane.scrollTo(0, 0);
    }
  };

  const replaceMergeFields = (str: string, order: number = 1) => {
    if (str.indexOf("{surveyor}") >= 0) {
      if (truckNomination.result && truckNomination.result.surveyor)
        return str.replace("{surveyor}", truckNomination.result.surveyor);
      else return str.replace("{surveyor}", "surveyor");
    } else if (str.indexOf("{n}") >= 0) {
      return str.replace("{n}", toOrdinalString(order));
    } else if (str.indexOf("{vesseltype}") >= 0) {
      return str.replace(
        "{vesseltype}",
        truckNomination.result ? truckNomination.result.vesselType : "Vessel"
      );
    } else {
      return str;
    }
  };

  const renderRows = () => {
    const istruckNominationSelected = truckNomination.result === undefined;
    const maxGroupIndex2 = 8;

    let buttonRows = [];
    let hasActiveYet = false;
    const activeStatus = [0, 1, 5];
    const filteredActivities =
      activityLogs.result &&
      activityLogs.result
        .sort((a, b) => a.id - b.id)
        .filter(
          (f) =>
            (f.state === selectedState || f.state === "") &&
            nominationNo.toUpperCase() === f.nominationNo
        );
    //console.log("steps", steps);
    if (filteredActivities && filteredActivities.length > 0) {
      for (let ctr = 0; ctr <= maxGroupIndex2; ctr++) {
        const rowId = `row-${ctr}`;
        let hasElement = false;
        let divGroup = (
          <div
            key={`action-group-${ctr}`}
            id={rowId}
            className="action-button-group ms-Grid-row"
          >
            {steps
              .filter(
                (f) =>
                  f.groupIndex === ctr &&
                  (!f.processFlowStateId ||
                    f.processFlowStateId === selectedStateId)
              )
              .sort((s1, s2) => s1.order - s2.order)
              // eslint-disable-next-line no-loop-func
              .map((step) => {
                let items: ActivityItem[] = [];

                if (filteredActivities) {
                  const stepActivityLogs = filteredActivities.filter(
                    (f) =>
                      f.processStepId === step.id &&
                      //temporarily use linehandlingno while there is no api yet
                      nominationNo.toUpperCase() === f.nominationNo
                    // (nominationNo === null || nominationNo === f.nominationNo)
                  );

                  if (stepActivityLogs.length > 0) {
                    const distinctSurveyors = stepActivityLogs
                      .map((s) => s.surveyor)
                      .filter((s, i, ss) => ss.indexOf(s) === i);

                    const maxRepeationOrder = Math.max.apply(
                      null,
                      stepActivityLogs.map((s) => s.repetitionOrder)
                    );

                    for (var _surveyor of distinctSurveyors) {
                      const sstepActivityLogs = stepActivityLogs.filter(
                        (f) => f.surveyor === _surveyor
                      );
                      const lastActivitylog =
                        sstepActivityLogs[sstepActivityLogs.length - 1];
                      const startActivities = sstepActivityLogs.find(
                        (f) =>
                          f.repetitionOrder === maxRepeationOrder &&
                          f.status === 1
                      );
                      const endActivities = sstepActivityLogs.find(
                        (f) =>
                          f.repetitionOrder === maxRepeationOrder &&
                          f.status === 2
                      );
                      let isStartOffline =
                        startActivities && startActivities.offline;
                      let isEndOffline = endActivities && endActivities.offline;
                      const startedOn =
                        startActivities &&
                        (isStartOffline
                          ? moment
                              .utc(startActivities.logTime)
                              .format("YYYY-MM-DD HH:mm:ss")
                          : startActivities.logTime);
                      const finishedOn =
                        endActivities &&
                        (isEndOffline
                          ? moment
                              .utc(endActivities.logTime)
                              .format("YYYY-MM-DD HH:mm:ss")
                          : endActivities.logTime);
                      const description = lastActivitylog.description;
                      const status = lastActivitylog.status;
                      const order = lastActivitylog.repetitionOrder;
                      items = [
                        ...items,
                        {
                          status,
                          startedOn,
                          finishedOn,
                          description,
                          surveyor: _surveyor,
                          order,
                          isStartOffline,
                          isEndOffline,
                        } as ActivityItem,
                      ];
                    }
                  }
                }

                if (items.length === 0) {
                  items = [{ description: step.name } as ActivityItem];
                }

                return items.map((item, index) => {
                  let itemId = `step-${step.id}`;
                  // if (
                  //   item.status === undefined &&
                  //   !SofProcessor.checkConditions(
                  //     step.displayConditions,
                  //     nomination,
                  //     []
                  //   )
                  // )
                  //   return <Fragment />;
                  if (
                    !hasActiveYet &&
                    item.status !== undefined &&
                    activeStatus.indexOf(item.status) >= 0
                  ) {
                    itemId = `first-active-row`;
                    hasActiveYet = true;
                  }
                  if (
                    item.status !== 4 &&
                    !(item.status === undefined && step.hide)
                  ) {
                    hasElement = true;
                    return (
                        <Fragment key={`${step.id}-${index}`}>
                            <div
                                    onClick={() => {
                                      if (item.status !== undefined) {
                                        setSelectedStep(step);
                                        setSurveyor(item.surveyor);
                                        if (
                                          (activeStatus.indexOf(item.status) >= 0 &&
                                            !truckNomination.result?.isRejected) ||
                                          (activeStatus.indexOf(item.status) >= 0 &&
                                            truckNomination.result?.isRejected &&
                                            item.description === "Departure")
                                        ) {
                                          setShowActionModal(true);
                                          setShowTimeStampModal(false);
                                        } else if (item.status === 2) {
                                          setShowActionModal(false);
                                          setShowTimeStampModal(true);
                                        } else if (truckNomination.result?.isRejected) {
                                        }
                                      }
                                }}
                                className="activity-step-v2"
                                style={{ display: 'flex', justifyContent: 'space-between', padding: '16px 8px', alignItems: 'center', cursor: 'pointer' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ width: 48, height: 48, marginRight: 10 }}>
                                        {item.status === undefined && (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="48" height="48" rx="24" fill="#F3F4F6"></rect><mask id="mask0_6_381" maskUnits="userSpaceOnUse" x="12" y="12" width="24" height="24"><rect x="12" y="12" width="24" height="24" fill="#D9D9D9"></rect></mask><g mask="url(#mask0_6_381)"><path d="M19.25 24.75H28.75V23.25H19.25V24.75ZM24.0016 33.5C22.6877 33.5 21.4527 33.2506 20.2966 32.752C19.1404 32.2533 18.1347 31.5765 17.2795 30.7217C16.4243 29.8669 15.7472 28.8616 15.2483 27.706C14.7494 26.5504 14.5 25.3156 14.5 24.0017C14.5 22.6877 14.7493 21.4527 15.248 20.2966C15.7467 19.1404 16.4234 18.1347 17.2783 17.2795C18.1331 16.4243 19.1383 15.7472 20.294 15.2483C21.4496 14.7494 22.6844 14.5 23.9983 14.5C25.3122 14.5 26.5473 14.7493 27.7034 15.248C28.8596 15.7467 29.8652 16.4234 30.7205 17.2783C31.5757 18.1331 32.2527 19.1383 32.7516 20.294C33.2505 21.4496 33.5 22.6844 33.5 23.9983C33.5 25.3122 33.2506 26.5473 32.752 27.7034C32.2533 28.8596 31.5765 29.8652 30.7217 30.7205C29.8669 31.5757 28.8616 32.2527 27.706 32.7516C26.5504 33.2505 25.3156 33.5 24.0016 33.5ZM24 32C26.2333 32 28.125 31.225 29.675 29.675C31.225 28.125 32 26.2333 32 24C32 21.7666 31.225 19.875 29.675 18.325C28.125 16.775 26.2333 16 24 16C21.7666 16 19.875 16.775 18.325 18.325C16.775 19.875 16 21.7666 16 24C16 26.2333 16.775 28.125 18.325 29.675C19.875 31.225 21.7666 32 24 32Z" fill="#A3A3A3"></path></g></svg>

                                        )}
                                        {item.status === 0 && (
                                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="play_circle">
                                                    <mask id="mask0_6_371" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                        <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
                                                    </mask>
                                                    <g mask="url(#mask0_6_371)">
                                                        <path id="play_circle_2" d="M9.75 16.0384L16.0384 12L9.75 7.96155V16.0384ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z" fill="#1D4ED8" />
                                                    </g>
                                                </g>
                                            </svg>

                                        )}
                                        {item.status === 1 && (
                                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="clock_loader_10">
                                                    <mask id="mask0_5_45" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                        <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
                                                    </mask>
                                                    <g mask="url(#mask0_5_45)">
                                                        <path id="clock_loader_10_2" d="M12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 10.9333 19.7984 9.90991 19.3952 8.92978C18.992 7.94966 18.4159 7.0846 17.667 6.3346L12 12V3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z" fill="#06B6D4" />
                                                    </g>
                                                </g>
                                            </svg>

                                        )}
                                        {item.status === 2 && (
                                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="check_circle">
                                                    <mask id="mask0_6_416" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                        <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
                                                    </mask>
                                                    <g mask="url(#mask0_6_416)">
                                                        <path id="check_circle_2" d="M10.5808 16.2538L17.3038 9.53075L16.25 8.47693L10.5808 14.1462L7.73075 11.2962L6.67693 12.35L10.5808 16.2538ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z" fill="#16A34A" />
                                                    </g>
                                                </g>
                                            </svg>

                                        )}
                                        {item.status === 3 && (
                                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="block">
                                                    <mask id="mask0_26_4878" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                        <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
                                                    </mask>
                                                    <g mask="url(#mask0_26_4878)">
                                                        <path id="block_2" d="M12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C12.9382 20 13.8417 19.8413 14.7104 19.524C15.5791 19.2067 16.3731 18.7474 17.0923 18.1461L5.85383 6.90765C5.25896 7.62688 4.80127 8.42086 4.48075 9.28958C4.16023 10.1583 3.99998 11.0618 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20ZM18.1461 17.0923C18.7474 16.3731 19.2067 15.5791 19.524 14.7104C19.8413 13.8417 20 12.9382 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C11.0595 3.99998 10.1539 4.15703 9.28308 4.47113C8.41228 4.78524 7.62047 5.24614 6.90765 5.85383L18.1461 17.0923Z" fill="#DC2626" />
                                                    </g>
                                                </g>
                                            </svg>
                                        )}
                                        {item.status === 5 && (
                                            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="pause_circle">
                                                    <mask id="mask0_6_443" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                                                        <rect id="Bounding box" width="24" height="24" fill="#D9D9D9" />
                                                    </mask>
                                                    <g mask="url(#mask0_6_443)">
                                                        <path id="pause_circle_2" d="M9.40385 15.75H10.9038V8.25H9.40385V15.75ZM13.0961 15.75H14.5961V8.25H13.0961V15.75ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z" fill="#D97706" />
                                                    </g>
                                                </g>
                                            </svg>

                                        )}

                                    </div>
                                    <div>
                                        <div style={{ fontSize: 16, fontWeight: 700, lineHeight: '24px' }}>
                                            {item.description}
                                        </div>
                                        <div style={{ fontSize: 14, fontWeight: 400, lineHeight: '24px' }}>
                                            {item.status === undefined && "Inactive"}
                                            {item.status === 0 && "To Do"}
                                            {item.status === 1 && "In Progress"}
                                            {item.status === 2 && "Done"}
                                            {item.status === 3 && "Skipped"}
                                            {item.status === 5 && "Paused"}
                                            </div>
                                    </div>
                                </div>
                                <div style={{ marginRight: 24 }}>
                                    {item.finishedOn &&
                                    <Moment
                                        format="HH:mm - ll"
                                        local
                                    >{`${item.finishedOn} UTC`}
                                        </Moment>
                                    }
                                </div>
                            </div>
                        {/*<div id={itemId} className="ms-Grid-col ms-md3 ms-sm4">
                        {/*  <div*/}
                        {/*    id={`btn-step-${step.id}`}*/}
                        {/*    className={`action-button status-${*/}
                        {/*      item.status === undefined ? "00" : item.status*/}
                        {/*    }`}*/}
                        {/*    onClick={() => {*/}
                        {/*      if (item.status !== undefined) {*/}
                        {/*        setSelectedStep(step);*/}
                        {/*        setSurveyor(item.surveyor);*/}
                        {/*        if (*/}
                        {/*          (activeStatus.indexOf(item.status) >= 0 &&*/}
                        {/*            !truckNomination.result?.isRejected) ||*/}
                        {/*          (activeStatus.indexOf(item.status) >= 0 &&*/}
                        {/*            truckNomination.result?.isRejected &&*/}
                        {/*            item.description === "Departure")*/}
                        {/*        ) {*/}
                        {/*          setShowActionModal(true);*/}
                        {/*          setShowTimeStampModal(false);*/}
                        {/*        } else if (item.status === 2) {*/}
                        {/*          setShowActionModal(false);*/}
                        {/*          setShowTimeStampModal(true);*/}
                        {/*        } else if (truckNomination.result?.isRejected) {*/}
                        {/*        }*/}
                        {/*      }*/}
                        {/*    }}*/}
                        {/*  >*/}
                        {/*    <div*/}
                        {/*      className={`action-header status-${*/}
                        {/*        item.status === undefined ? "00" : item.status*/}
                        {/*      }`}*/}
                        {/*    >*/}
                        {/*      <span className="action-header-title">*/}
                        {/*        {item.status === undefined && "Inactive"}*/}
                        {/*        {item.status === 0 && "To Do"}*/}
                        {/*        {item.status === 1 && "In Progress"}*/}
                        {/*        {item.status === 2 && "Done"}*/}
                        {/*        {item.status === 3 && "Skipped"}*/}
                        {/*        {item.status === 5 && "Paused"}*/}
                        {/*      </span>*/}
                        {/*      <span className="action-header-icon">*/}
                        {/*        {item.status === undefined && (*/}
                        {/*          <FontIcon iconName="StatusCircleBlock" />*/}
                        {/*        )}*/}
                        {/*        {item.status === 0 && (*/}
                        {/*          <FontIcon iconName="CaretHollow" />*/}
                        {/*        )}*/}
                        {/*        {item.status === 1 && (*/}
                        {/*          <FontIcon iconName="ProgressRingDots" />*/}
                        {/*        )}*/}
                        {/*        {item.status === 2 && (*/}
                        {/*          <FontIcon iconName="CheckMark" />*/}
                        {/*        )}*/}

                        {/*        {item.status === 3 && (*/}
                        {/*          <FontIcon iconName="Cancel" />*/}
                        {/*        )}*/}

                        {/*        {item.status === 5 && (*/}
                        {/*          <FontIcon iconName="Pause" />*/}
                        {/*        )}*/}
                        {/*      </span>*/}
                        {/*    </div>*/}

                        {/*    <span className="action-desc">*/}
                        {/*      {item.description &&*/}
                        {/*        replaceMergeFields(*/}
                        {/*          item.description,*/}
                        {/*          item.order*/}
                        {/*        )}*/}
                        {/*    </span>*/}

                        {/*    <div className="action-footer">*/}
                        {/*      <div style={{ display: "inline-block" }}>*/}
                        {/*        {item.startedOn && (*/}
                        {/*          <span*/}
                        {/*            style={*/}
                        {/*              item.isStartOffline*/}
                        {/*                ? { color: "rgb(184, 184, 184)" }*/}
                        {/*                : {}*/}
                        {/*            }*/}
                        {/*          >*/}
                        {/*            <i className="act-time-icon"></i>*/}
                        {/*            <Moment format="HH:mm - ll" local>*/}
                        {/*              {`${item.startedOn} UTC`}*/}
                        {/*            </Moment>*/}
                        {/*          </span>*/}
                        {/*        )}*/}

                        {/*        {item.startedOn && item.finishedOn && (*/}
                        {/*          <div className="vconnector"></div>*/}
                        {/*        )}*/}

                        {/*        {item.finishedOn && (*/}
                        {/*          <span*/}
                        {/*            style={*/}
                        {/*              item.isEndOffline*/}
                        {/*                ? { color: "rgb(184, 184, 184)" }*/}
                        {/*                : {}*/}
                        {/*            }*/}
                        {/*          >*/}
                        {/*            <i*/}
                        {/*              className="act-time-icon"*/}
                        {/*              style={{*/}
                        {/*                backgroundColor: "#D32F2F",*/}
                        {/*              }}*/}
                        {/*            ></i>*/}
                        {/*            <Moment*/}
                        {/*              format="HH:mm - ll"*/}
                        {/*              local*/}
                        {/*            >{`${item.finishedOn} UTC`}</Moment>*/}
                        {/*          </span>*/}
                        {/*        )}*/}
                        {/*      </div>*/}
                        {/*    </div>*/}
                        {/*  </div>*/}
                        {/*</div>*/}

                        </Fragment>
                    );
                  }
                });
              })}
          </div>
        );

        if (hasElement) buttonRows.push(divGroup);
      }
    }
    if (buttonRows.length === 0) {
      if (istruckNominationSelected && selectedState === "...") {
        buttonRows.push(
          <div key="nom-status" className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <NominationsStatusPane />
            </div>
          </div>
        );
      } else {
        buttonRows.push(
          renderMessage("No activity to show in the current view..")
        );
      }
    }
    return buttonRows;
  };

  const onStateChange = (
    newState: string,
    _truckNomination: TruckNomination,
    updatedActivityLogs: ActivityLog[]
  ) => {
    let nextActionType: NextActionType = NextActionType.NEXT_STATE;
    let msg: string = `${selectedState} operations are done. Proceed to ${newState} to continue.<br />Click "Ok" to proceed to the next stage, or "Cancel" to remain in the current view.`;
    const activeActivities = SofProcessor.getCurrentActivityPerStep(
      updatedActivityLogs
    ).filter(
      (f) =>
        f.state === newState &&
        (truckNomination.result === undefined ||
          f.nominationNo === nominationNo) &&
        activeStatus.indexOf(f.status) >= 0
    );

    // if (!nominationNo) {
    //   if (_truckNomination.status === 3) {
    //     msg = "All operations for this line handling are complete.";
    //     nextActionType = NextActionType.FINISHED;
    //   } else {
    //     if (activeActivities && activeActivities.length > 0) {
    //       // default values
    //     } else {
    //       if (_truckNomination.status && _truckNomination.status < 2) {
    //         msg = `${selectedState} operations are done. No current operation for Line Handling. To continue, select a nomination.`;
    //         nextActionType = NextActionType.SELECT_NOMINATION;
    //       } else {
    //         msg = "This Line Handling is done";
    //         nextActionType = NextActionType.FINISHED;
    //       }
    //     }
    //   }
    // } else {
    if (activeActivities && activeActivities.length > 0) {
      // default values
    } else {
      if (_truckNomination.status && _truckNomination.status < 2) {
        msg = `This nomination is done. Please select a different nomination to continue.`;
        nextActionType = NextActionType.SELECT_NOMINATION;
      } else {
        msg =
          "All nominations are done. Go back to Line Handling view to proceed.";
        nextActionType = NextActionType.BACK_TO_LINE_HANDLING;
      }
    }
    // }

    setNewState(newState);
    setModalMessage(msg);
    setNextActionType(nextActionType);
    setShowNewStateModal(true);
  };

  const refreshData = async (hasError: boolean, isOnClose: boolean = false) => {
    if (hasError) {
      const { search } = history.location;
      const q = queryString.parse(search.toLowerCase());
      const nominationno = q.nomination as string | undefined;

      if(!isOnClose) {
        props.getActivityLogsByNomination(nominationNo.toUpperCase(), () => {
          props.getTruckNomination(nominationNo, false, false, () => {
            let previousPage = `/truck/${nominationNo}/sof`;
            // if (nominationno) {
            //   previousPage += `?nomination=${nominationno}`;
            // }
            if (history.location.search !== previousPage) {
              // history.push(previousPage);
            }
          });
        });
      }
    }

    setSelectedStep(undefined);
  };

  useEffect(() => {
    if (config && selectedState) {
      if (activityLogs.result) {
        var stepList: ProcessFlowStep[] = [];

        const activityLogGrpIndex = activityLogs.result.filter(
          (a) => a.groupIndex != null
        );
        config.steps.forEach((step) => {
          var activityLog = activityLogGrpIndex.find(
            (a) => a.processStepId === step.id
          );
          var groupIndex = step.groupIndex;
          if (
            activityLog &&
            activityLog.groupIndex &&
            !isNaN(activityLog.groupIndex)
          )
            groupIndex = Number(activityLog.groupIndex);

          stepList.push({ ...step, groupIndex });
        });
          console.log({ stepList })
        setSteps(stepList);
      } else {
          console.log({ steps: config.steps })
        setSteps(config.steps);
      }

      const state = config.states.find((f) => f.name === selectedState);
      state && setSelectedStateId(state.id);
    }

    // truckNomination.result &&
    // setLineHandlingNo(lineHandling.result.lineHandlingNo);
    // setNominationNo(
    //   truckNomination ? truckNomination.result.nominationNo : undefined
    // );
  }, [config, activityLogs, selectedState, props.truckNomination]);

  useEffect(() => scrollIntoActiveView());

  useEffect(() => {
    if (selectedStep === undefined) {
      setShowTimeStampModal(false);
      setShowActionModal(false);
    } else {
      scrollIntoActiveView();
    }
  }, [selectedStep]);

  useEffect(() => {
    if(props?.truckNomination?.result){
      if (props.rejectionStatus === 1) {
        setShowRejectImgUploadModal(true);
      } 
      else if(props.sofViewRejection) {
        setShowRejectImgUploadModal(true);
      }
      else {
        setShowRejectImgUploadModal(false);
      }
    }
  }, [props.rejectionStatus,props.sofViewRejection]);

  useEffect(() => {
    pushNotification.connection.off("ActionExecuted");

    pushNotification.connection.on("ActionExecuted", (message) => {
      const result = message as string[];
      if (
        result[0].toUpperCase() === nominationNo?.toUpperCase() &&
        result[1] !== props.correlationId
      ) {
        refreshData(true);
      }
    });

    return () => pushNotification.connection.off("ActionExecuted");
  }, []);

    console.log({ sofView })

  return (
    <>
      {selectedStep && showActionModal && props.isTruckEditActivityAllowed && (
        <ActionModal
          {...props}
          correlationId={props.correlationId}
          step={selectedStep}
          surveyor={surveyor}
          onCancel={(hasError: boolean) => refreshData(hasError,true)}
          onStateChange={onStateChange}
        />
      )}

      {showRejectImgUploadModal && (
        <RejectionImageUploadModal
          nominationNo={nominationNo}
          onCancel={async () => {
            if(props.sofViewRejection){
              await props.checkSofViewRejection(false)
            }
            setShowRejectImgUploadModal(false);
           
          }}
          onCloseSuccess={ async () => {
            if(props.sofViewRejection){
              await props.checkSofViewRejection(false)
            }
            setShowRejectImgUploadModal(false);
            refreshData(true);
          }}
        />
      )}

      {selectedStep && showTimeStampModal && (
        <TimeStampModal
          {...props}
          step={selectedStep}
          surveyor={surveyor}
          readonly={!props.isTruckEditTimestampAllowed}
          onClose={() => {
            setSelectedStep(undefined);
            refreshData(true,true);
          }}
        />
      )}
      <div id="activities-pane" className="activities-pane">
        {/*{sofView === SofView.NominationEdit && (*/}
        {/*  <div className={classes.disabledBG} />*/}
        {/*)}*/}
        <div className="ms-Grid" dir="ltr">
          {activityLogs.isLoading && <ApiSpinner />}
          {!activityLogs.isLoading &&
            sofView === SofView.None &&
            renderMessage(
              "Activities will appear after selecting a nomination."
            )}
          {!activityLogs.isLoading && sofView !== SofView.None && renderRows()}
        </div>
        {sofView !== SofView.None && <div className={classes.filler} />}
      </div>
      {selectedState && (
        <NextStateModal
          currentState={selectedState}
          nextState={newState}
          message={modalMessage}
          display={showNewStateModal}
          actionType={nextActionType}
          onClick={() => {
            setShowNewStateModal(false);
            switch (nextActionType) {
              case NextActionType.NEXT_STATE:
                props.setSelectedState(newState);
                break;
              case NextActionType.SELECT_NOMINATION:
                props.setSelectedState(newState);
                break;
              case NextActionType.BACK_TO_LINE_HANDLING:
                if (
                  props.truckNomination.result &&
                  props.truckNomination.result.currentState
                ) {
                  props.setSelectedState(
                    props.truckNomination.result.currentState
                  );
                  history.push(`/truck/${props.nominationNo}/sof`);
                }
                break;
              case NextActionType.FINISHED:
                break;
            }
          }}
          onCancel={() => setShowNewStateModal(false)}
        />
      )}
    </>
  );
};
export default ActivityLogsPage;
